import { Component, input } from '@angular/core';
import { AppIcon, IconComponent } from '@tablesready/frontend-icons';
import { IonicModule } from '@ionic/angular';
import { FrontendDropdownComponent } from '../frontend-dropdown/frontend-dropdown.component';

@Component({
  selector: 'frontend-dropdown-clear',
  templateUrl: './frontend-dropdown-clear.component.html',
  styleUrls: ['./frontend-dropdown-clear.component.scss'],
  imports: [IconComponent, IonicModule],
})
export class FrontendDropdownClearComponent {
  dropdown = input<FrontendDropdownComponent<any>>();
  icon = AppIcon;

  get visible(): boolean {
    const d = this.dropdown();
    return !!d && d.clearable && d.value?.length > 0 && !d.disabled;
  }

  clearAll(): void {
    this.dropdown()?.clearAll();
  }
}
